module.exports = __webpack_public_path__ + "static/img/img-12.058aa76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-12.png
// module id = E6bu
// module chunks = 1